<template>
  <vs-card v-if="showComponent">
    <div slot="header">
      <h3>{{ title }}</h3>
    </div>

    <div>
      <div v-if="listArquivos.length == 0" class="p-5">
        <h6>Não há fotos ou documentos a serem exibidos.</h6>
      </div>
      <div v-else class="vx-row">
        <div
          class="vx-col lg:w-1/2 xl:w-1/4 w-full mt-5"
          v-for="arquivo in listArquivos"
          :key="arquivo.idEventoFoto"
        >
          <vs-card :class="{ remove: arquivo.deletar }">
            <div class="flex justify-between">
              <div class="p-2 break-all">
                <p class="text-lg">
                  {{
                    arquivo.nomeTipoArquivo
                      ? `Tipo: ${arquivo.nomeTipoArquivo}`
                      : null
                  }}
                </p>
                <p>{{ arquivo.legenda || arquivo.nome }}</p>
                <p>{{ formatDateHour(arquivo.updatedAt) }}</p>
                <p>{{ arquivo.nomeUsuario }}</p>
              </div>

              <div class="flex gap-2">
                <vs-button
                  v-tooltip="'Baixar arquivo'"
                  type="gradient"
                  color="success"
                  icon="save"
                  size="small"
                  @click="downloadArquivo(arquivo)"
                ></vs-button>

                <vs-button
                  v-if="arquivo.deletar"
                  v-tooltip="'Deletar arquivo'"
                  type="gradient"
                  color="success"
                  icon="undo"
                  size="small"
                  @click="undoArquivoToDelete(arquivo)"
                ></vs-button>

                <vs-button
                  v-else
                  v-tooltip="'Deletar arquivo'"
                  type="gradient"
                  color="danger"
                  icon="close"
                  size="small"
                  @click="selectArquivoToDelete(arquivo)"
                ></vs-button>
              </div>
            </div>

            <div>
              <a
                v-if="isPdf(arquivo.nome)"
                class="flex justify-center"
                :href="arquivo.nome"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  class="w-1/2"
                  src="../../../../../assets/images/elements/PDF_file_icon2.png"
                />
              </a>

              <a
                v-else-if="isVideo(arquivo.nome)"
                class="flex justify-center"
                :href="arquivo.nome"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  class="w-1/2"
                  src="../../../../../assets/images/elements/video_file_icon.png"
                />
              </a>

              <a
                v-else-if="isAudio(arquivo.nome)"
                class="flex justify-center"
                :href="arquivo.nome"
                target="_blank"
                rel="noopener noreferrer"
              >
                <audio class="w-full" :src="arquivo.nome" controls muted loop />
              </a>

              <img
                v-else
                @click="openModalDetalhesFoto(arquivo)"
                class="w-full cursor-pointer"
                :src="arquivo.nome"
              />
            </div>
          </vs-card>
        </div>
      </div>

      <div v-if="listArquivos.length >= filesCapacityLimit">
        <vs-alert title="Atenção" active="true" color="danger">
          Você chegou ao limite máximo de {{ filesCapacityLimit }} fotos. Favor
          remover fotos atuais para poder acrescentar novas fotos.
        </vs-alert>
      </div>

      <div class="flex justify-between items-center mt-5 lg:flex-row flex-col">
        <div class="p-5">
          <span class="colorBlue">
            Limite de fotos: {{ listArquivos.length }} /
            {{ filesCapacityLimit }}
          </span>
        </div>
        <div class="flex gap-3 lg:flex-row flex-col">
          <vs-button
            color="danger"
            :disabled="!listArquivosToDelete.length"
            @click="deleteRegistroArquivos()"
          >
            <div class="flex items-center gap-2">
              <feather-icon icon="Trash2Icon" />
              <span
                >Deletar: {{ listArquivosToDelete.length }} arquivos
                selecionados</span
              >
            </div>
          </vs-button>

          <vs-button
            @click="openModalUpload(idReferente)"
            :disabled="listArquivos.length >= filesCapacityLimit"
          >
            <div class="flex items-center gap-2">
              <feather-icon icon="UploadIcon" />Upload
            </div>
          </vs-button>
        </div>
      </div>

      <vs-popup
        title="Fotos e Documentos"
        :active.sync="modalFotoAtivo"
        fullscreen
      >
        <div v-if="itemModalSelecionado">
          <div class="flex justify-center m-5">
            <h4>
              {{
                itemModalSelecionado.legenda
                  ? itemModalSelecionado.legenda
                  : itemModalSelecionado.nome
              }}
            </h4>
          </div>
          <div class="flex justify-center m-5 mb-32">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="2"
              class="sm:p-2 p-4 gap-x-1 z-40"
            >
              <vs-button
                icon-pack="feather"
                icon="icon-arrow-left"
                color="warning"
                class="z-40"
                @click="mudaFoto('anterior')"
              />
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="3"
              class="sm:p-2 p-4 gap-x-1 z-40"
            >
              <vs-button
                icon-pack="feather"
                icon="icon-rotate-ccw"
                color="primary"
                class="z-40"
                @click="rotateLeft"
              />
              <div
                class="z-40 bg-white px-3 rounded flex flex-col items-center"
              >
                <span>Zoom</span>
                <vs-switch
                  @change="toggleZoom"
                  color="success"
                  v-model="zoomFotoSwitch"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
              <vs-button
                icon-pack="feather"
                icon="icon-rotate-cw"
                color="primary"
                class="z-40"
                @click="rotateRight"
              />
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="2"
              class="sm:p-2 p-4 gap-x-1 z-40"
            >
              <vs-button
                icon-pack="feather"
                icon="icon-arrow-right"
                color="warning"
                class="z-40"
                @click="mudaFoto('próximo')"
              />
            </vs-col>
          </div>
          <div
            class="teste"
            :style="{
              height: zoomFotoSwitch ? '204.8rem' : '102.4rem',
              width: zoomFotoSwitch ? '204.8rem' : '102.4rem',
            }"
          >
            <img
              class="h-full w-full object-contain"
              :style="{ transform: 'rotate(' + rotationAngle + 'deg)' }"
              :src="itemModalSelecionado.nome"
            />
          </div>
        </div>
      </vs-popup>

      <vs-popup
        :title="this.titleModalUpload"
        :active.sync="modalUploadAtivo"
        :id="`idReferente${idReferente}`"
      >
        <div v-if="!listArquivosToUpload.length" class="m-5 mb-10">
          <h5>Não há arquivos selecionados</h5>
        </div>
        <div v-else class="flex flex-wrap">
          <div
            v-for="(arquivo, index) in listArquivosToUpload"
            :key="index"
            class="lg:w-1/2 w-full p-5"
          >
            <vs-card>
              <div class="flex justify-end">
                <vs-button
                  v-tooltip="'Deletar arquivo'"
                  type="gradient"
                  color="danger"
                  icon="close"
                  size="small"
                  class="mb-2"
                  @click="deleteArquivoUpload(index)"
                ></vs-button>
              </div>

              <div class="flex justify-center">
                <img
                  v-if="isPdf(arquivo.nome)"
                  class="w-1/2"
                  src="../../../../../assets/images/elements/PDF_file_icon2.png"
                />
                <video
                  v-if="isVideo(arquivo.nome)"
                  class="w-full"
                  :src="arquivo.url"
                  controls
                  muted
                  loop
                ></video>
                <audio
                  v-else-if="isAudio(arquivo.nome)"
                  class="w-1/2"
                  :src="arquivo.url"
                  controls
                  muted
                  loop
                />
                <img v-else class="w-full" :src="arquivo.url" />
              </div>
              <div class="mt-2">
                <vs-input
                  label="Legenda do arquivo:"
                  class="w-full"
                  :value="arquivo.legenda"
                  @change="
                    updateArquivo(arquivo, 'legenda', $event.target.value)
                  "
                ></vs-input>
              </div>
              <div class="mt-2">
                <label class="vs-select--label">Tipo de Arquivo:</label>
                <v-select
                  :options="listTiposArquivos"
                  label="description"
                  :reduce="(item) => item.archiveTypeId"
                  v-model="listIdsTipoArquivoSelecionados[index]"
                  @input="
                    updateArquivo(
                      arquivo,
                      'idTipoArquivo',
                      listIdsTipoArquivoSelecionados[index],
                    )
                  "
                ></v-select>
              </div>
            </vs-card>
          </div>
        </div>
        <div
          v-if="
            listArquivosToUpload.length + listArquivos.length >=
            filesCapacityLimit
          "
          class="mb-3"
        >
          <vs-alert title="Atenção" active="true" color="danger">
            <span v-if="listArquivos.length">
              Você já possui {{ listArquivos.length }} fotos salvas.
            </span>
            Subindo essas fotos, você chegará ao limite total máximo de
            {{ filesCapacityLimit }}
            fotos. Favor remover fotos atuais para poder acrescentar novas
            fotos.
          </vs-alert>
        </div>

        <div class="flex justify-end gap-5">
          <vs-button
            @click="openEscolhaArquivoUpload(idReferente)"
            :disabled="
              listArquivosToUpload.length + listArquivos.length >=
              filesCapacityLimit
            "
            color="warning"
          >
            <div class="flex items-center gap-2">
              <feather-icon icon="PlusIcon" />Escolher arquivos
            </div>
          </vs-button>
          <input
            :id="`fileUpload${idReferente}${idTerceiro}`"
            type="file"
            accept="image/*, video/*, audio/*,.pdf"
            @change="selectArquivoUpload"
            name="files"
            hidden
            multiple
            enctype="multipart/form-data"
          />

          <vs-button
            @click="uploadArquivosSelecionados()"
            :disabled="
              listArquivosToUpload.length + listArquivos.length >
                filesCapacityLimit || !listArquivosToUpload.length
            "
          >
            <div class="flex items-center gap-2">
              <feather-icon icon="UploadIcon" />Upload:
              {{ listArquivosToUpload.length }} arquivos selecionados
            </div>
          </vs-button>
        </div>
      </vs-popup>
    </div>
  </vs-card>
</template>

<script>
import jwt from 'jsonwebtoken';
import moment from 'moment';
import serviceEventos from '../service/index';
import vSelect from 'vue-select';

import service from '../../../../../services';
import notify from './../../../../../utils/notify';

export default {
  props: {
    formData: Object,
    arquivos: Array,
    idReferente: Number,
    title: {
      type: String,
      default: 'Cadastrar Fotos e Documentos',
    },
  },
  components: { vSelect },
  data() {
    return {
      showComponent: true,
      idEvento: null,
      idTerceiro: null,
      idUsuario: null,
      idEmpresa: null,
      modalFotoAtivo: false,
      modalUploadAtivo: false,
      titleModalUpload: null,
      itemModalSelecionado: null,
      listArquivosToUpload: [],
      listArquivosToDelete: [],
      listArquivos: [],
      listTiposArquivos: [],
      filesCapacityLimit: 100,
      files: [],
      itemModalIndex: 0,
      rotationAngle: 0,
      zoomFotoSwitch: false,
      listIdsTipoArquivoSelecionados: [],
    };
  },
  watch: {
    formData(value) {
      this.idEvento = value.idEvento;
      this.idTerceiro = value.idTerceiro || null;
    },
    arquivos(value) {
      this.listArquivos = value;
    },
  },
  methods: {
    openModalDetalhesFoto(arquivo) {
      this.modalFotoAtivo = true;
      this.itemModalSelecionado = arquivo;
    },
    async openModalUpload(idReferente) {
      if (!this.listTiposArquivos.length) {
        await this.buscaTiposArquivos();
      }

      this.modalUploadAtivo = true;
      this.titleModalUpload = 'Upload de Fotos e Documentos';

      switch (idReferente) {
        case 1:
          this.titleModalUpload += ' - Dados Gerais';
          break;

        case 2:
          this.titleModalUpload += ' - Reparo do Veículo';
          break;

        case 3:
          this.titleModalUpload += ' - Terceiros';
          break;
      }
    },
    openEscolhaArquivoUpload() {
      document
        .getElementById(`fileUpload${this.idReferente}${this.idTerceiro}`)
        .click();
    },
    selectArquivoUpload(event) {
      const fileList = event.target.files;

      if (!fileList.length) {
        return;
      }

      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i];
        this.listArquivosToUpload.push({
          legenda: this.getNomeArquivoSemExtensao(file.name),
          url: URL.createObjectURL(file),
          nome: file.name,
        });
        this.files.push(file);
      }
    },
    getNomeArquivoSemExtensao(nomeArquivo) {
      const ultimoPontoIndex = nomeArquivo.lastIndexOf('.');

      if (ultimoPontoIndex !== -1) {
        return nomeArquivo.substring(0, ultimoPontoIndex);
      }

      return nomeArquivo;
    },
    isPdf(urlArquivo) {
      const ext = urlArquivo.split('.').pop();

      return ext === 'pdf' ? true : false;
    },
    isVideo(urlArquivo) {
      const ext = urlArquivo.split('.').pop().toLowerCase();
      const videoExtensions = [
        'mp4',
        'm4v',
        'avi',
        'mkv',
        'mov',
        'wmv',
        'flv',
        'webm',
        'mpeg',
        'quicktime',
      ];

      return videoExtensions.includes(ext);
    },
    isAudio(urlArquivo) {
      const ext = urlArquivo.split('.').pop().toLowerCase();
      const audioExtensions = [
        'mp3',
        'wav',
        'ogg',
        'flac',
        'aac',
        'm4a',
        'wma',
      ];

      return audioExtensions.includes(ext);
    },
    updateArquivo(arquivo, propriedade, valor) {
      if (arquivo && propriedade && valor) arquivo[propriedade] = valor;
    },
    deleteArquivoUpload(index) {
      this.listArquivosToUpload.splice(index, 1);
      this.listIdsTipoArquivoSelecionados.splice(index, 1);

      const deletedFile = this.listArquivosToUpload[index];
      const fileIndex = this.files.findIndex(
        (file) => file.name === deletedFile.nome,
      );

      if (fileIndex !== -1) {
        this.files.splice(fileIndex, 1);
      }
    },
    selectArquivoToDelete(arquivoSelecionado) {
      arquivoSelecionado.deletar = true;
      this.listArquivosToDelete.push(arquivoSelecionado);
    },
    undoArquivoToDelete(arquivoSelecionado) {
      delete arquivoSelecionado.deletar;

      const index = this.listArquivosToDelete.findIndex(
        (item) => item.idArquivo === arquivoSelecionado.idArquivo,
      );

      if (index !== -1) {
        this.listArquivosToDelete.splice(index, 1);
      }
    },
    async registraArquivosUpload(files, listArquivosToUpload) {
      try {
        const listFiles = [];

        files.forEach((file, index) => {
          listFiles.push({
            idEvento: this.idEvento,
            idTerceiro: this.idTerceiro,
            idFotoReferente: this.idReferente,
            nome: file,
            legenda: listArquivosToUpload[index].legenda,
            uploadBy: this.idUsuario,
            idTipoArquivo: listArquivosToUpload[index].idTipoArquivo,
          });
        });

        const result = await service.post(
          'eventos2',
          'registrar-fotos-documentos',
          listFiles,
        );

        // POG
        setTimeout(() => {
          this.listArquivos = result.data;
        }, 500);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async uploadArquivosSelecionados() {
      try {
        this.$vs.loading();

        const formDataSend = new FormData();

        this.files.forEach((file) => {
          formDataSend.append('files', file);
        });

        const { uploadedFiles } = await service.uploadAll(
          'upload-multi',
          'Eventos/' + this.idEvento,
          formDataSend,
        );

        await this.registraArquivosUpload(
          uploadedFiles,
          this.listArquivosToUpload,
        );

        this.modalUploadAtivo = false;
        this.listArquivosToUpload = [];
        this.files = [];
        this.listIdsTipoArquivoSelecionados = [];
      } catch (error) {
        notify.notifyFail(this.$vs, 'Não foi possível subir os arquivos');
        console.log(error);
      } finally {
        this.$vs.loading.close();
      }
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');

      if (token) {
        const decoded = jwt.decode(token);
        this.idUsuario = decoded.id_usuario;
        this.idEmpresa = decoded.id_empresa;
      }
    },
    async deleteRegistroArquivos() {
      try {
        this.$vs.loading();

        const objSend = {
          idEvento: this.idEvento,
          idTerceiro: this.idTerceiro,
          idFotoReferente: this.idReferente,
          ids: [],
        };

        this.listArquivosToDelete.forEach((file) => {
          if (file.deletar) {
            objSend.ids.push(file.idEventoFoto);
          }
        });

        const result = await service.post(
          'eventos2',
          'deletar-fotos-documentos',
          objSend,
        );

        this.listArquivos = result.data;
      } catch (error) {
        notify.notifyFail(this.$vs, 'Não foi possível deletar os arquivos');
        console.log(error);
      } finally {
        this.listArquivosToDelete = [];
        this.$vs.loading.close();
      }
    },
    formatDateHour(value) {
      if (!value) {
        return '';
      }

      return moment(value).format('DD/MM/YYYY HH:mm');
    },
    mudaFoto(param) {
      const currentIndex = this.arquivos.findIndex(
        (image) =>
          image.idEventoFoto === this.itemModalSelecionado.idEventoFoto,
      );

      const updatedIndex =
        param === 'próximo'
          ? (currentIndex + 1) % this.arquivos.length
          : param === 'anterior'
          ? (currentIndex - 1 + this.arquivos.length) % this.arquivos.length
          : currentIndex;

      this.itemModalSelecionado = this.arquivos[updatedIndex];
      this.openModalDetalhesFoto(this.itemModalSelecionado);
    },
    rotateLeft() {
      this.rotationAngle -= 90;
    },
    rotateRight() {
      this.rotationAngle += 90;
    },
    toggleZoom() {
      this.zoomFotoSwitch = !this.zoomFotoSwitch;
    },
    async buscaTiposArquivos() {
      try {
        this.$vs.loading();
        const resultTipoArquivo = await serviceEventos.getListTipoArquivoEvento(
          this.idEmpresa,
        );
        this.listTiposArquivos = resultTipoArquivo.data;
      } catch (error) {
        console.error(error);
        notify.notifyFail(
          this.$vs,
          'Não foi possível buscar os tipos de arquivos do sinistro.',
        );
      } finally {
        this.$vs.loading.close();
      }
    },
    async downloadArquivo(arquivo) {
      this.$vs.loading();
      try {
        const imageUrl = arquivo.nome;
        const encodedUrl = encodeURIComponent(imageUrl);

        const response = await service.getBlob('eventos2', {
          path: `downloadArquivo/${encodedUrl}`,
          responseType: 'blob',
        });

        const element = document.createElement('a');
        element.href = URL.createObjectURL(response);
        element.setAttribute('download', imageUrl.split('/').pop());

        document.body.appendChild(element);
        element.click();

        document.body.removeChild(element);
        this.$vs.loading.close();
      } catch (error) {
        console.error('Erro ao baixar o arquivo:', error);
        window.open(arquivo.nome, '_blank');
        this.$vs.loading.close();
      }
    },
  },
  mounted() {
    this.getDecoded();

    this.idEvento = this.formData.idEvento;
    this.idTerceiro = this.formData.idTerceiro || null;
    this.listArquivos = this.arquivos;
  },
};
</script>

<style>
.colorBlue {
  color: #00bfed;
}

.remove {
  background-color: rgb(252 165 165);
  color: black;
}

.teste {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
}
</style>
